import React from "react";
import Widget from "../Widget";
import { observer, inject } from "mobx-react";
import "./Labs.scss";
import LabsStore from "./LabsStore";
import Loader from "../../shared/Loader/Loader";
import Grid from "../../shared/Grid/Grid";
import _ from "lodash";

class Labs extends Widget {
  constructor(props) {
    super(props);
    this.setRouteProps(["asmpid"]);
    this.store = new LabsStore();
    this.props.store.labsStore = this.store;
    this.store.fetchLabs({ asmpid: this.asmpid });
    this.refresh = this.refresh.bind(this);
  }

  render() {
    return (
      <div className="labs widget">
        {this.store.loading ? (
          <Loader />
        ) : _.get(this.store.labs, "groups", []).length ? (
          <Grid
            labs={this.store.labs}
            reverse={true}
            history={this.props.history}
          />
        ) : (
          <div className="no-data">No Labs</div>
        )}
      </div>
    );
  }

  refresh() {
    this.store.fetchLabs({ asmpid: this.asmpid });
  }
}

export default inject("store")(observer(Labs));
